import { render } from "./UseIcon.vue?vue&type=template&id=46380240"
import script from "./UseIcon.vue?vue&type=script&lang=js"
export * from "./UseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__